<template>
    <v-container class="chained-dialog-component">
        <div class="dialog-wrapper">
            <div v-if="$route.name != 'reservationView'" 
                class="close d-flex flex-row align-center pt-5 ml-4 ml-md-0" 
                @click="backToOrigin">
                <img :src="closeIcon" class="icon mr-4"/><span class="label">{{$t('page.go_back')}}</span>
            </div>
            <div class="slot-wrapper" v-for="slot in slots" :key="slot.index">
                <slot :name="slot.name" v-if="currentSlot == slot.index">{{slot.name}}</slot>
            </div>
        </div>
    </v-container>
</template>

<script>

export default {
    name: "chained-dialog-component",
    data() {
        return {
            slots: []
        }
    },
    props: {
        slotCount: {
            type: Number,
            default: 3
        },
        currentSlot: {
            type: Number,
            default: 1
        },
        closeIcon: {
            type: String,
            default: 'mdi-close'
        },
    },
    created() {
        this.slots = []
        for(let index = 1; index <= this.slotCount; index++) {
            this.slots.push({
                name: 'slot_' + index,
                index
            })
        }
    },
    methods: {
        backToOrigin() {
            this.$router.push(this.$router.options.history.state.back);
        }
    }
}
</script>

<style lang="scss" scoped>
.chained-dialog-component {
    z-index: 100;
    width: 100vw;
    min-height: calc(100vh - 64px);
    // background: $ds-secondary-300;
    padding: 0px;
    margin: 0px;
    .dialog-wrapper {
        max-width: 1200px;
        // margin: 0 auto;
        position: relative;
    }
    .close {
        cursor: pointer;
        .label {
            text-decoration: underline;
        }
    }
}

@media (min-width: 960px) {
    
}
</style>